module.exports = __webpack_public_path__ + "static/img/back-button.ca4d2e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back-button.png
// module id = 8h5P
// module chunks = 0